import React, {useState, useContext} from 'react';
import axios from 'axios';
import moment from "moment";
import {Link, useHistory} from 'react-router-dom';
import {Alert, Button, Col, Form, Row} from 'react-bootstrap';
import {useLocalStorage} from 'react-use';
import AuditContext from '../Utils/context.js';
import {ACTIONS} from '../Utils/action.js';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import MinutesModal from '../Modal/Minutes/Admin.js';

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

export default function Visitation() {

  const history = useHistory();
  const {schedule, dispatchSchedule} = useContext(AuditContext);

  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert();
  const [showMinutes, setShowMinutes] = useState(false);

  const canUpdate = () => {

    // except VISITATED (Visitation is on progress)
    if (!['VISITED', 'APPROVED', 'COMPLETED'].includes(schedule.SCHEDULE_STATUS)) {
        return <Alert variant="info" style={{textAlign: 'center'}}>Visitation is on progress.</Alert>;
    }

    // except APPROVED (Waiting admin for approval)
    if (!['EVALUATED', 'APPROVED', 'COMPLETED'].includes(schedule.SCHEDULE_STATUS)) {
      return <Button variant="success" onClick={handleApproveMinutes}>Approve</Button>;
    }

    // except COMPLETED (done)
    if (!['EVALUATED', `VISITED`, 'COMPLETED'].includes(schedule.SCHEDULE_STATUS)) {
      return <Alert variant="info" style={{textAlign: 'center'}}>Visitation Process has been completed.</Alert>;
    }
  }

  const handleSendEmail = async () => {
    try {
      let formData = new FormData();
      formData.append('TYPE', 'CREATE_FINDING');
      formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
      formData.append('SCHEDULE', schedule.SCHEDULE_ID);
      const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        }
      });
    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleApproveMinutes = () => {
    handleSendEmail();
    setShowMinutes(<MinutesModal onHide={handleHideMinutes} onSubmit={handleSubmitMinutes} schedule={schedule}/>);
  }


  const handleSubmitMinutes = (statement, id) => {

    try {

      const onSuccessCallback = async () => {

        const response = await axios.put(
          `${process.env.REACT_APP_API_HOST}minutes/${id}`,
          {
            BPMI_NOTE: statement,
            APPROVED_AT: moment().format('YYYY-MM-DD hh:mm:ss'),
            APPROVED_BY: auth.employee.EMP_ID,
          },
          {
            params: {expand: 'schedule'},
            headers: {Authorization: `Bearer ${auth.token}`}
          }
        );

        const responseSchedule = await axios.put(
          `${process.env.REACT_APP_API_HOST}schedules/${schedule.SCHEDULE_ID}`,
          {SCHEDULE_STATUS: 'APPROVED'},
          {headers: {Authorization: `Bearer ${auth.token}`}}
        )

        dispatchSchedule({
          type: ACTIONS.EDIT,
          payload: {SCHEDULE_STATUS: responseSchedule.data.SCHEDULE_STATUS},
        });

        handleHideMinutes();
        history.push(`/admin/audits/${schedule.SCHEDULE_ID}/findings`);
      }

      const confirmDialog = confirm("Are you sure?");
      if (confirmDialog) {
        onSuccessCallback();
      }

    } catch (error) {
      alert(error);
      console.log(error);
    }

  }

  const getVariant = (form) => {

    switch (true) {
      case (form?.VISIT_AT !== null && form?.VISIT_BY !== null):
        return 'success';
      case (form?.EVALUATE_AT !== null && form?.EVALUATE_BY !== null):
        return 'primary';
      default:
        return 'secondary';
    }
  }

  const handleHideMinutes = () => {
    setShowMinutes(null);
  }

  return (
    <>
      {swal}
      {showMinutes}
      <h3>Visitation</h3>
      <Form.Group>
        {schedule.forms && schedule.forms.map((form, key) => (
          <Link key={key} to={`/admin/visitations/${form.FORM_ID}`}>
            <Button variant={getVariant(form)}>{form.criteria.CRITERIA_CODE}. {form.criteria.CRITERIA_LABEL}</Button> {' '}
          </Link>
        ))}
      </Form.Group>
      <Form.Group>
        {canUpdate()}
      </Form.Group>
    </>
  )
}